import React, { useMemo } from "react"

import Collapsible from '~components/Collapsible'
import SidebarTag from "./SidebarTag"
import { isResourcePath, isTagNotEmpty } from "./utils"
import { compareVersions } from '../../../utils/versioning'

import * as style from "./Sidebar.module.scss"

const SidebarDeprecatedTags = ({
  tags, bodyHeight, microcopy, location,
}) => {
  const isResource = isResourcePath(location.pathname)
  const toLookFor = isResource ? tags.map((tag) => tag.resources) : tags.map((tag) => tag.endpoints)
  const pathToLookFor = location.pathname
  const isSelected = !isResource && (toLookFor || []).flat().map((e) => e.path).some((p) => p === pathToLookFor)

  const sortedTags = useMemo(
    () => tags.filter(isTagNotEmpty)
      .sort((a, b) => compareVersions(a.version, b.version))
      .sort((a, b) => a.name.localeCompare(b.name)),
    [tags],
  )

  return (
    <Collapsible
      header={(
        <h3>
          <span className={isSelected ? style.activeParent : ''}>
            {microcopy.text("reference.sidebar.titles.deprecated_entries")}
          </span>
        </h3>
      )}
      className={`${style.collapsible} ${style.tag}`}
      headerClassName={`${style.level_1} ${style.collapsibleHeader}`}
      open={isSelected}
    >
      <ul className={style.collapsibleBody}>
        {sortedTags.map((tag) => (
          <li tabIndex={0} key={`${tag.id}-${tag.version}`}>
            <SidebarTag
              key={tag.id}
              tag={tag}
              endpointsByVersion={{ [tag.version]: tag.endpoints }}
              resourcesByVersion={{ [tag.version]: tag.resources }}
              location={location}
              bodyHeight={bodyHeight}
              deprecated
              identLevel={1}
              withVersion
            />
          </li>
        ))}
      </ul>
    </Collapsible>
  )
}

export default SidebarDeprecatedTags
